// reCAPTCHA v3 helpers shared by public forms (register, client trial)

const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

// Adds the reCAPTCHA script once; safe to call from every form
export const loadRecaptcha = () => {
  if (document.getElementById("recaptcha-script")) return;
  const script = document.createElement("script");
  script.id = "recaptcha-script";
  script.src = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}`;
  script.async = true;
  document.body.appendChild(script);
};

// Resolves to "" if reCAPTCHA didn't load (e.g. blocked); the backend rejects that
export const getRecaptchaToken = (action) =>
  new Promise((resolve) => {
    if (!window.grecaptcha) {
      resolve("");
      return;
    }
    window.grecaptcha.ready(() => {
      window.grecaptcha
        .execute(RECAPTCHA_SITE_KEY, { action })
        .then(resolve, () => resolve(""));
    });
  });
